module.exports = __webpack_public_path__ + "static/hero-718d249665432e19d03e62e725373dbf.svg";